<template>
  <div class="case-order-wait tb">
    <div class="search-hd">
      <el-form
        :inline="true"
        class="search-form"
      >
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="onAddCase"
            v-if="funcView.add_case_order"
          >{{ funcView.add_case_order }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('asm_case_order_wait.aldhjshsbrlxr')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('asm_case_order_wait.shang_bao_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.gmtCreateTimes"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('asm_case_order_wait.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 租赁方 -->
        <el-form-item :label="$t('asm_case_order_wait.zu_lin_fang')">
          <el-input
            v-model="formSearch.customerName"
            :placeholder="$t('Common.com_please_input')"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_case_order_wait.xiang_mu')">
          <el-input
            v-model="formSearch.locationName"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('asm_case_order_wait.shou_hou_gong_si')">
          <el-input
            v-model="formSearch.afterServiceName"
            :placeholder="$t('Common.com_please_input')"
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        :column="tableColumn"
        :index="true"
        :slots="['caseOrderCode','bodyNum']"
      >
        <!-- 目前维修和保养类型,返修单可以进入详情 -->
        <template v-slot:caseOrderCode="scope">
          <span
            v-if="[10, 20, 50].includes(scope.row.serviceClass) && funcView.case_order_detail"
            class="cell-link"
            @click="toDetail(scope.row)"
          >{{ scope.row.caseOrderCode }}</span>
          <span v-else>{{ scope.row.caseOrderCode }}</span>
        </template>
        <template v-slot:bodyNum="scope">
          <span
            class="cell-link"
            v-if="funcView.case_order_device_detail"
            @click="toDeviceDetail(scope.row)"
          >{{scope.row.bodyNum}}</span>
          <span v-else>{{scope.row.bodyNum}}</span>
        </template>
      </custom-table>
    </div>
    <!-- 分页 -->
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <add-case-dialog
      v-if="addCaseVisible"
      @close="addCaseVisible = false"
      :model="addCaseModel"
      @success="onPageChange({ page: 1 })"
    ></add-case-dialog>

    <select-device-dialog
      v-if="selectDeviceVisible"
      @close="selectDeviceVisible = false"
      :model="selectDeviceModel"
      @confirm="onSelectDeviceConfirm"
    ></select-device-dialog>
    <select-service-type-dialog
      v-if="selectTypeVisible"
      @close="selectTypeVisible = false"
      :model="selectTypeModel"
      @success="onSelectTypeSuccess"
    ></select-service-type-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';
import addCaseDialog from '@/pages/asm/components/add_case_dialog';
import selectDeviceDialog from '@/pages/asm/components/select_device_dialog.vue';
import selectServiceTypeDialog from './select_service_type_dialog.vue';
import orderMixin from './orderMixin';

export default {
  name: '',
  mixins: [resetFormSearchMixins, orderMixin, languageInjectMixins],
  components: {
    // switchButton,
    // switchContainer,
    addCaseDialog,
    selectDeviceDialog,
    selectServiceTypeDialog
  },
  props: {},
  data() {
    return {
      tableCode: 'case_order_wait',
      tableList: [],
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        caseOrderState: [20],
        gmtCreateTimes: [],
        createStartTime: '',
        createEndTime: '',
        productCode: '',
        customerName: '',
        locationName: '',
        afterServiceName: '',
      },
      totalRows: 0,
      addCaseVisible: false,
      addCaseModel: {},

      selectDeviceVisible: false,
      selectDeviceModel: {},

      selectTypeVisible: false,
      selectTypeModel: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onSelectTypeSuccess() {
      this.onPageChange({ page: 1 });
    },
    toDetail(item) {
      this.toCaseOrderDetail(item);
    },
    // (按照现有的需求，是先去选择设备；- 2023-07-20)
    // 添加服务单
    onAddCase() {
      this.selectDeviceModel = {
        title: this.$t('asm_case_order_wait.xuan_ze_she_bei'),
      };
      this.selectDeviceVisible = true;
    },
    onSelectDeviceConfirm(e) {
      const deviceItem = e[0];
      const title = this.$t('asm_case_order_wait.xzfwlxo', [deviceItem.bodyNum]);

      this.selectTypeModel = {
        title,
        data: deviceItem
      };

      this.selectTypeVisible = true;

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      if (this.formSearch.caseOrderState && !this.formSearch.caseOrderState.length) {
        this.formSearch.caseOrderState = [20];
      }
      this.formSearch.createStartTime = this.formSearch.gmtCreateTimes ? this.formSearch.gmtCreateTimes[0] : '';
      this.formSearch.createEndTime = this.formSearch.gmtCreateTimes ? this.formSearch.gmtCreateTimes[1] : '';
      this.$getJSON(apis.caseOrderPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onSearch() {
      this.onPageChange({ page: 1 });
    },
  },
  created() { },
  mounted() {
    this.getFuncView();
    this.getTableColumn();
    this.getTableList();
  },
};
</script>

<style lang="scss">
.case-order-wait {
  padding: 0 16px 0 16px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .case-order-code {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
